<template>
  <div class="home">
    <a-row :gutter="16">
      <a-col :span="24">
        <a-card title="Regulamin">
          <ol>
            <li>
              Należy bezwzględnie podporządkować się zarządzeniom
              administratorów sieci.
            </li>
            <li>Nie wolno wykorzystywać sieci do celów komercyjnych.</li>
            <li>Nie wolno rozpowszechniać nielegalnego oprogramowania.</li>
            <li>
              Osoba podłączona do sieci musi być mieszkańcem D.S. Politechniki
              Świętokrzyskiej
            </li>
            <li>
              Należy przestrzegać następujących zasad związanych z
              funkcjonowaniem sieci lokalnej:
            </li>

            <ol>
              <li>
                Osoba dysponująca wadliwym sprzętem (np. kartą sieciową),
                wpływającą szkodliwie na pracę całej sieci jest zobowiązana do
                odpięcia wadliwego urządzenia od sieci lokalnej,
              </li>
              <li>
                Podpinanie się do sieci może następować tylko i wyłącznie za
                zgodą administratorów sieci,
              </li>
              <li>
                Wszelkie zmiany usytuowania komputera (zmiana pokoju, itp.),
                mogą odbywać się w porozumieniu z administratorami sieci,
              </li>
              <li>
                Nie wolno używać swojego wejścia do sieci do celów niezgodnych z
                przeznaczeniem (eksperymentowanie),
              </li>
              <li>
                W przypadku korzystania z sieci Microsoft Windows obowiązuje
                następujący format identyfikacji komputera:
              </li>
              <ul>
                <li>nazwa komputera: dowolne, ale cenzuralne określenie,</li>
                <li>grupa robocza: Nazwa Twojego Akademika,</li>
                <li>
                  opis komputera: musi zawierać: imię, nazwisko oraz numer
                  pokoju użytkownika.
                </li>
              </ul>
              <li>
                Inne protokoły niż TCP/IP są dozwolone tylko za zgodą
                administratora sieci lokalnej.
              </li>
            </ol>

            <li>
              Osoba przyłączona do sieci ponosi pełną odpowiedzialność za:
            </li>
            <ul>
              <li>
                wszelkie dane i programy znajdujące się w pamięci i/lub na
                dyskach komputera podłączonego do sieci;
              </li>
              <li>szkody wyrządzone innym użytkownikom;</li>
              <li>
                odcinek sieci znajdujący się w obrębie pokoju, w którym znajduje
                się podłączony komputer;
              </li>
            </ul>
            <li>
              Prywatne strony (np. WWW, FTP, itp.) mogą być udostępnione tylko i
              wyłącznie za zgodą administracji sieci.
            </li>
            <li>
              Sieć jest plombowana i każda próba rozłączanie sieci wiąże się z
              natychmiastowym odłączeniem od sieci.
            </li>
            <li>
              Administrator ma prawo kontrolować wykorzystywane protokoły i stan
              plomb oraz wezwać użytkownika na rozmowę w przypadku działań
              niezgodnych z regulaminem.
            </li>
            <li>
              Każdego użytkownika komputera obowiązuje instalacja programu
              antywirusowego oraz firewalla.
            </li>
            <li>
              Administratorzy sieci nie są zobowiązani do konfiguracji systemów
              operacyjnych czy programów używanych przez osoby podłączone do
              sieci; udzielają jedynie informacji o parametrach niezbędnych do
              działania komputera w sieci.
            </li>
            <li>
              Niepoprawne skonfigurowanie używanego oprogramowania powodujące
              nieprawidłowe działanie sieci (np. ręczne wpisanie swojego numeru
              IP) może się wiążąc z czasowym odłączeniem od sieci osoby za to
              odpowiedzialnej.
            </li>
          </ol>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "Regulamin",
  components: {},
  mounted() {
    this.$emit("loadedView");
  },
};
</script>